/**
 * Calculates the weight of an item based on its order in the list.
 *
 * @param {Number} after   The weight of the item that it goes after.
 * @param {Number} before  The weight of the item that it comes before.
 * @returns {Number}       The calculated weight of the item.
 */
export function calculateWeight(after, before) {

	// This is the first item of the list
	if ((after === null || typeof after === 'undefined') &&
		(before === null || typeof before === 'undefined')) {
		return 10;
	}

	// Add to start of list
	if (after === null || typeof after === 'undefined') {
		return before - 10;
	}

	// Add to end of list
	if (before === null || typeof before === 'undefined') {
		return after + 10;
	}

	// Place between the other two items
	return ((before - after) / 2) + after;

}

/**
 * Sorts a list of items based on ascending weight.
 *
 * @param {array} items The list of items.
 *
 * @returns {array} result  The list of sorted items.
 */
export function sortByWeight(items) {

	const result = items ? [...items] : [];

	// Sort the items based on ascending weight
	result.sort((item1, item2) => {

		const weight1 = parseFloat(item1.weight);
		const weight2 = parseFloat(item2.weight);

		// Leave the items in original order if missing a valid weight
		if (isNaN(weight1) || isNaN(weight2)) {
			return -1;
		}

		return weight1 - weight2;

	});

	return result;

}
